<template>
  <div class="section">
    <div class="job-header">
      <h1 class="is-size-3 has-text-primary">Job #{{job.id}}</h1>
      <div v-if="job.employer === (user && user.id)">
        <router-link :to="{name:'job-edit', params: {id: job.id}, passProps: {job}}"
          class="button is-primary has-margin-right" tag="a">Edit</router-link>
        <button class="button is-outlined is-danger" @click="confirmDelete">Delete</button>
      </div>
      <div v-else-if="user">
        <button class="button is-outlined is-danger"
          :disabled="alreadyReported"
          @click="initiateReport">{{ alreadyReported ? 'Already Reported!' : 'Report'}}</button>
      </div>
    </div>
    <div class="columns">
      <div class="column" v-for="i in job.images" :key="i.id">
        <img :src="i.file.file" />
      </div>
    </div>
    <p><em>{{job.short_description}}</em></p>
    <p><em>{{job.description}}</em></p>
    <div class="columns job-attributes">

      <div class="column">
        <TagLabelItem label="Job type" :values="[job.type || 'N/A']" />
        <TagLabelItem label="Position type" :values="[job.employment_type || 'N/A']" />
        <TagLabelItem label="Country from" :values="[job.country_from || 'N/A']" />
        <TagLabelItem label="Harbor from" :values="[job.harbor_from || 'N/A']" />
        <TagLabelItem label="Country to" :values="[job.country_to || 'N/A']" />
        <TagLabelItem label="Harbor to" :values="[job.harbor_to || 'N/A']" />
        <TagLabelItem label="Duration" :values="[
          `${job.from_date || 'N/A'} ${job.to_date ? ` - ${job.to_date}` : '(Permanent)'}`
        ]" />
        <TagLabelItem label="Published at" :values="[$moment(job.created).fromNow()]" />
      </div>

      <div class="column">
        <TagLabelItem label="Payment" :values="[$money(job.salary)]" />
        <TagLabelItem label="Vessel size"
          :values="[job.vessel_size_ft ?
          `${job.vessel_size_ft}ft (${$toMeters(job.vessel_size_ft)}m)`:
          'N/A']" />
        <TagLabelItem label="Skills" :values="job.skills" />
        <TagLabelItem label="Boat ownership" :values="[job.vessel_ownership_type || 'N/A']" />
        <TagLabelItem label="Boat type" :values="[job.vessel_type || 'N/A']" />
        <TagLabelItem label="Boat sub type" :values="[job.vessel_sub_type || 'N/A']" />
      </div>

      <div class="column" v-if="canSeePrivateContent">
        <TagLabelItem label="Name" :values="[employerName || 'N/A']" />
        <TagLabelItem label="Email" :values="[employer.email]" />
        <TagLabelItem label="Phone" :values="[employer.profile.phone_number || 'N/A']" />
        <TagLabelItem label="WhatsApp" :values="[employer.profile.whatsapp_number || 'N/A']" />
        <TagLabelItem label="Skype" :values="[employer.profile.skype_id || 'N/A']" />
      </div>
      <div class="column" v-else>
        <HiddenArea />
      </div>
    </div>
  </div>
</template>

<script>
import TagLabelItem from '@/components/TagLabelItem';
import HiddenArea from '@/components/HiddenArea';
import ReportModal from '@/views/common/JobDetails/ReportModal';
import { mapState, mapGetters } from 'vuex';


export default {
  components: {
    TagLabelItem,
    HiddenArea,
  },
  data() {
    return {
      justReported: false,
    };
  },
  props: {
    job: Object,
    employer: Object,
    report: Object,
  },
  computed: {
    ...mapGetters({
      canSeePrivateContent: 'auth/canSeePrivateContent',
    }),
    ...mapState({
      user: state => state.auth.user,
    }),
    employerName() {
      return [
        this.employer.profile.first_name,
        this.employer.profile.last_name,
        this.employer.profile.company_name,
      ].filter(p => !!p).join(', ');
    },
    alreadyReported() {
      return this.report || this.justReported;
    },
  },
  methods: {
    confirmDelete() {
      this.$dialog.confirm({
        title: 'Deleting Job',
        message: `Are you sure you want to <b>delete</b> Job #${this.job.id}? This action cannot be undone.`,
        confirmText: 'Delete Job',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          await this.$http.delete(`jobs/${this.job.id}/`);
          this.$router.replace({ name: 'jobs' });
          this.$toast.open('Job deleted!');
        },
      });
    },
    initiateReport() {
      this.$modal.open({
        component: ReportModal,
        events: {
          reportSaved: async (r) => {
            try {
              await this.$http.post(
                'job_reports/',
                { ...r, reporter: this.user.id, job: this.job.id },
              );
            } catch (e) {
              // already reported, do nothing
            }
            this.justReported = true;
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.job-attributes {
  margin-top: 1rem
}
.job-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
